import React from "react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <>
      <SEO title="Page not found | Infinity Medical Group" description="The page you are looking for could not be found." />
      <section className="min-h-[80vh] flex items-center bg-cream py-20" data-testid="not-found">
        <div className="container max-w-2xl text-center">
          <p className="text-xs uppercase tracking-[0.32em] font-semibold text-teal">Error 404</p>
          <h1 className="mt-6 font-display font-bold text-5xl md:text-7xl tracking-tight text-navy-800">
            We could not find that page.
          </h1>
          <p className="mt-6 text-lg text-navy-700/75">
            The page may have moved or no longer exists. Please return home or explore our divisions.
          </p>
          <Link
            to="/"
            data-testid="not-found-home"
            className="mt-10 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-navy text-white text-sm font-semibold hover:bg-teal transition-colors"
          >
            <ArrowLeft className="h-4 w-4" /> Back to home
          </Link>
        </div>
      </section>
    </>
  );
}
